
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"81","height":"81","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.831 33.832L37.165 50.499l-6.667-6.667","stroke":"#00D7A3","stroke-width":"6","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M35.053 9.816a31.26 31.26 0 0120.53 3.39A31.23 31.23 0 0169.429 28.73a31.205 31.205 0 01-8.886 35.794M46.596 71.18a31.26 31.26 0 01-20.867-3.163 31.23 31.23 0 01-14.094-15.7 31.205 31.205 0 018.909-35.739","stroke":"#00D7A3","stroke-width":"6","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    